import styled from 'styled-components';
import ds, { media } from 'designsystem';

const Wrapper = styled.div`
  padding: ${ds.get('metrics.m')} 0;
  background-color:${ds.brand('white')};

  ${media.desktop`
    width: 500px;
    height: 700px;
    position: absolute;
    top:-200px;
    right: 100px;
    padding: ${ds.get('metrics.l')};
    z-index:1;
  `};
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/pages/Blog/LatestArticle/Wrapper.jsx